import type { ReportGroupBy, RevenueReportView } from '@cuito/types';
import { apiClient } from '../lib/apiClient';

/**
 * 社团侧报表（`04-api-contract.md` §16.1）—— 与平台侧**同一个端点**。
 *
 * ## 可见范围**不是参数**
 *
 * 「社团看自己」由**调用方主体**决定（服务端强制注入 `tenantId`），因此查询类型里
 * **没有 `scope` / `scopeId`**：加上它就等于让社团自己填别人的 `tenantId`（A-P8-06）。
 * `apps/tenant/src/api/reports.spec.ts` 有一条反向断言（请求参数里不许出现 `scope`）。
 *
 * ## 金额只显示不计算
 *
 * 四个金额一律是服务端算好的字符串；本层零 `Number()` / 零加减 / 零 `toFixed`。
 * 恒等式 `netAmount = grossAmount − refundAmount` 的唯一实现在 `@cuito/types`。
 *
 * ## 不做地点 / 展会下钻（**Phase 9**）
 *
 * 规格 §3.2 的 `/reports` 行原有「地点选择 / `请选择展会或门店`」，
 * 已由控制器于 `eb7ec5f` 就地删掉：`scope` 下钻属 Phase 9。本模块因此**没有** `scopeId` 参数。
 */

export type {
  ReportGroupBy,
  RevenueReportView,
  RevenueSeriesPoint,
  RevenueTenantRow,
} from '@cuito/types';

export interface RevenueQuery {
  /** 不传 ⇒ `series` 是空数组（契约 §16.1） */
  groupBy?: ReportGroupBy;
  from?: string;
  to?: string;
}

export const reportsApi = {
  revenue: (params: RevenueQuery = {}) =>
    apiClient.get<RevenueReportView>('/reports/revenue', { params }),
};
